import { Component, OnInit } from '@angular/core';
import { MensagemService } from 'maestro-ng';
import { FonteDados } from '../../fonte-dados/fonte-dados.model';
import { FonteDadosService } from '../../fonte-dados/fonte-dados.service';
import { RespostaProcessamento } from '../../mensagem-controle/resposta-processamento.model';
import { ProcessoService } from '../../processo/processo.service';
import { LocalePtBr } from '../../util/locale-pt-br.model';

export enum ProcessamentoSituacao {
    EM_EXECUCAO = 'EM_EXECUCAO',
    PENDENTE = 'PENDENTE',
    EXECUTADO = 'EXECUTADO'
}

export class IdsProcessamento {

    public origemId: string;
    public fonteDados: string;
    public situacao: ProcessamentoSituacao;
    public resultado: RespostaProcessamento;
    public mensagemErro: string;

    constructor(fonteDados: string, origemId: string) {
      this.origemId = origemId;
      this.fonteDados = fonteDados;
      this.situacao = ProcessamentoSituacao.PENDENTE;
      this.resultado = undefined;
      this.mensagemErro = undefined;
    }
}

export class Executor {

    private timeout: any;
    private ativo = false;

    constructor(public coordenador: ManutencaoSincronizarProcessosComponent) {}

    public aguardar(): void {
      setTimeout(() => this.executar(), 500);
    }

    public ativar(): void {
      if (!this.ativo) {
        this.ativo = true;
        this.executar();
      }
    }

    public desativar(): void {
      this.ativo = false;
    }

    public executar(): void {
      if (this.ativo && this.coordenador.executando) {

        const id = this.coordenador.proximoIdProcessamento();

        if (id !== undefined) {

          id.situacao = ProcessamentoSituacao.EM_EXECUCAO;
          this.coordenador.service.sincronizar(id.fonteDados, id.origemId)
            .then(resposta => {
              id.resultado = resposta;
              id.situacao = ProcessamentoSituacao.EXECUTADO;
              this.executar();
            })
            .catch(resposta => {
              id.resultado = RespostaProcessamento.FALHA;
              id.situacao = ProcessamentoSituacao.EXECUTADO;
              id.mensagemErro = resposta.error;
              this.executar();
            });
        }
        else {
          this.coordenador.pararExecucao();
        }
      }
    }
}

@Component({
  selector: 'app-manutencao-sincronizar-processos',
  templateUrl: './manutencao-sincronizar-processos.component.html',
  styleUrls: ['./manutencao-sincronizar-processos.component.css']
})

export class ManutencaoSincronizarProcessosComponent implements OnInit {

    public fonteDadosItens: FonteDados[];
    public fonteDados: FonteDados;
    public ids = '';
    public idsProcessamento: IdsProcessamento[];
    public sincronizar = false;
    public executores: Executor[] = [];
    public executando = false;

    constructor(
        public mensagemService: MensagemService,
        public service: ProcessoService,
        private fonteDadosService: FonteDadosService,
        public ptBR: LocalePtBr
    ) {}

    public ngOnInit() {
      this.fonteDadosService.recuperarItens()
        .then(listaFonteDados => {
          this.fonteDadosItens = listaFonteDados;
        })
        .catch(resposta => {
          this.mensagemService.addErro('Erro', 'Erro ao encontrar fonte de dados: ' + resposta.message);
        });

      for (let i = 0; i < 5; i++) {
        this.executores.push(new Executor(this));
      }
    }

    sincronizarProcessos() {
      const listaIds = this.ids.replace(/\\n/, ' ').split(',').map(id => id.trim());
      if (listaIds !== undefined && listaIds.length > 0) {
        this.sincronizar = true;
        this.idsProcessamento = listaIds.map(id => new IdsProcessamento(this.fonteDados.nome, id));
        this.iniciarExecucao();
      }
      else {
        this.mensagemService.addAlerta('Preencher o campos', 'Necessário ao menos um origem Id para sincronização');
      }
    }

    public getMensagensPendentes() {
      return this.idsProcessamento.filter(ids => ids.situacao === ProcessamentoSituacao.PENDENTE);
    }

    public iniciarExecucao(): void {

      this.executando = true;

      if (this.getMensagensPendentes().length !== 0) {
        this.ativarExecutores();
      }
      else {
        this.desativarExecutores();
      }
    }

    public ativarExecutores() {
      this.executores.forEach(executor => executor.ativar());
    }

    public desativarExecutores() {
      this.executores.forEach(executor => executor.desativar());
    }

    public pararExecucao(): void {
      this.executando = false;
      this.desativarExecutores();
    }

    public proximoIdProcessamento(): IdsProcessamento {

      const idsPendentes = this.getMensagensPendentes();

      return idsPendentes.length > 0 ? idsPendentes[0] : undefined;
    }

}
